import { AppInfoType } from "../types/types";
import { AppRequirementsUrl } from "../constants/Constants";

const useApi = {
  getRequirements(): Promise<AppInfoType[]> {
    //console.debug("getting requirements from api");

    return fetch(AppRequirementsUrl, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((result: AppInfoType[]) => {
        //console.debug("api result:", result);
        return result;
      });
  },
};

export default useApi;
